<template>
  <div class="row">
    <div class="col-md-12">
      <SelectsV2
        v-if="enableSelect == 1"
        :callbackOnChangeEquipe="onChangeEquipe"
        :activeOptionSemEquipe="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
      <SelectsV2
        v-if="enableSelect == 2"
        :activeSelectEquipes="false"
        :activeSelectProfissionais="false"
        :activeSelectMicroArea="true"
        :callbackOnChangeMicroArea="onChangeMicroArea"
        :disabledMicroArea="loading"
      />
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            @exibirPretos="handleExibirPretos"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            :disabledBlack="disabledBlack"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="select-situacao info-table-item">
          <vue-select
            :options="filterMeses"
            label="label"
            placeholder="Meses"
            v-model="filter"
            @input="
              filter !== null
                ? filtros(
                    exibirCadastrosVermelhos,
                    exibirCadastrosVerdes,
                    exibirCadastrosPretos,
                    $event
                  )
                : filtros(
                    exibirCadastrosVermelhos,
                    exibirCadastrosVerdes,
                    exibirCadastrosPretos,
                    {
                      situacao: 'Todos',
                    }
                  )
            "
            :clearable="true"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="dose-imunizante"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import SelectsV2 from '@/components/utils/SelectsV2.vue'

export default {
  name: 'DoseImunizante',
  metaInfo: {
    title: 'Dose imunizante',
    titleTemplate: null,
  },
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
    SelectsV2,
  },
  mixins: [utils],
  data() {
    return {
      enableSelect: '',
      cadastrosOriginais: [],
      cadastros: [],
      equipe: '',
      micro_area: '',
      loading: false,
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      exibirCadastrosPretos: false,
      disabledRed: false,
      disabledGreen: false,
      disabledBlack: false,
      filterMeses: [
        { label: '4 meses', value: '4 meses' },
        { label: '5 meses', value: '5 meses' },
        { label: '6 meses', value: '6 meses' },
        { label: '9 meses', value: '9 meses' },
        { label: '12 meses', value: '12 meses' },
        { label: '15 meses', value: '15 meses' },
      ],
      filter: '',
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.cadastros
    },
  },
  methods: {
    /**
     * Atualiza o estado do filtro de busca da tabela.
     * @param {Object} item Item selecionado
     */
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    /**
     * Aplica o filtro de exibição de cadastros (vermelhos ou verdes).
     * @param {Boolean} vermelho Indica se o filtro de vermelhos deve ser aplicado
     * @param {Boolean} verde Indica se o filtro de verdes deve ser aplicado
     * @param {Boolean} preto Indica se o filtro de pretos deve ser aplicado
     * @param {Object|null} filter Fitro por meses
     */
    filtros(vermelho, verde, preto, filter) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      let data = Functions.formatarCadastrosComDoses(this.cadastrosOriginais)
      this.exibirCadastrosVerdes = false
      this.exibirCadastrosVermelhos = false
      this.exibirCadastrosPretos = false

      // Se null setar como vazio
      if (filter === null) {
        this.filter = ''
        filter = ''
      }
      if (filter !== '') {
        data = Functions.handleFilter(data, filter.value)
      }
      if (vermelho === true) {
        data = Functions.exibirVermelhos(data)
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        data = Functions.exibirVerdes(data)
        this.exibirCadastrosVerdes = true
      }

      if (preto === true) {
        data = Functions.exibirPretos(data)
        this.exibirCadastrosPretos = true
      }

      this.cadastros = data
    },

    /**
     * Atualiza o filtro para exibir registros classificados como vermelhos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          // mostra os vermelhos
          this.filtros(true, false, false, this.filter)
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
          this.exibirCadastrosPretos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    /**
     * Atualiza o filtro para exibir registros classificados como verdes.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          // mostra os verdes
          this.filtros(false, true, false, this.filter)
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
          this.exibirCadastrosPretos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    /**
     * Atualiza o filtro para exibir registros classificados como pretos.
     * @param {Boolean} event Indica se o filtro deve ser aplicado
     */
    handleExibirPretos(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      this.disabledBlack = true
      setTimeout(() => {
        if (event == true) {
          this.filtros(false, false, true, this.filter)
          this.exibirCadastrosPretos = true
          this.exibirCadastrosVerdes = false
          this.exibirCadastrosVermelhos = false
        } else {
          this.filtros(false, false, false, this.filter)
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.disabledBlack = false
        this.loading = false
      }, 1000)
    },

    /**
     * Manipula a alteração da equipe selecionada.
     *
     * @param {Object} event Equipe selecionada
     */
    async onChangeEquipe(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loading = true
        this.equipe = event
        this.cadastros = []
        this.cadastrosOriginais = []
        try {
          let response = await this.$api.get(
            '/app/v2/dose-imunizante/' +
              this.$store.state.cod_ibge +
              '/equipe/' +
              this.equipe.ine_esf_eap
          )
          if (response) {
            this.cadastrosOriginais = response.data
            this.cadastros = response.data
            this.filtros(true, false, false, this.filter)
            this.setRed = true
            this.loading = false
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.cadastros = []
        this.cadastrosOriginais = []
        this.equipe = ''
        return
      }
    },

    /**
     * Manipula a alteração da microárea selecionada.
     *
     * @param {Object} event Microárea selecionada
     */
    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.loading = true
        this.micro_area = event.micro_area
        this.cadastros = []
        this.cadastrosOriginais = []
        try {
          let response = await this.$api.get(
            '/app/v2/dose-imunizante/' +
              this.$store.state.cod_ibge +
              '/equipe/' +
              this.equipe.ine_esf_eap +
              '/microarea/' +
              this.micro_area
          )
          if (response) {
            this.cadastrosOriginais = response.data
            this.cadastros = response.data
            this.filtros(true, false, false, this.filter)
            this.setRed = true
            this.loading = false
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.cadastros = []
        this.cadastrosOriginais = []
        await this.onChangeEquipe(this.equipe)
        return
      }
    },

    /**
     * Gera o relatório em PDF.
     */
    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        this.equipe,
        this.micro_area
      )
    },

    /**
     * Inicializa os dados
     */
    async init() {
      try {
        // Enfermeiro, médico ...
        if (this.enableSelect == 2) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
            await this.onChangeEquipe(this.equipe)
          }
        }

        // ACS
        if (this.enableSelect == 3) {
          let equipe = this.$store.state.equipesV2.find((el) => {
            return el.ine_esf_eap == this.$store.state.nu_ine
          })
          if (equipe) {
            this.equipe = {
              ine_esf_eap: equipe.ine_esf_eap,
              no_equipe: equipe.no_esf_eap,
            }
          }
          this.micro_area = this.$store.state.micro_area
          await this.onChangeMicroArea({ micro_area: this.micro_area })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.enableSelect = this.enableSelects()
    this.init()
  },
}
</script>

<style></style>
